import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TokenState } from '../../@types/token';
import { dispatch } from '../store';

const initialState: TokenState = {
  token: '',
  refreshToken: '',
  validUntil: '',
};

const slice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setTokensAction: (
      state,
      { payload: { token, refreshToken } }: PayloadAction<{ token: string; refreshToken: string }>
    ) => {
      state.token = token;
      state.refreshToken = refreshToken;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setTokensAction } = slice.actions;

export function setTokens(token: string, refreshToken: string) {
  dispatch(slice.actions.setTokensAction({ token, refreshToken }));
}
